import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
import Root from 'frontend/components/programs/root';
import set from 'ember-set-helper/helpers/set';
<template>
  {{pageTitle (t "general.programs")}}
  <Root
    @setSchoolId={{set @controller "schoolId"}}
    @schoolId={{@controller.schoolId}}
    @schools={{@controller.model}}
  />
</template>
